import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Drug} from "../../model/drug";

@Component({
  selector: 'gen-drug-viewer',
  templateUrl: './drug-viewer.component.html',
  styleUrls: ['./drug-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DrugViewerComponent {

  @Input() drug: Drug;
  @Input() last: boolean;

  constructor() {
  }

  ngOnInit() {
  }
}
